import styled from 'styled-components'
import Badge_ from '@material-ui/core/Badge'

import theme from 'theme'

// eslint-disable-next-line import/prefer-default-export
export const Badge = styled(Badge_)`
  margin-left: ${theme.spacing(4)}px;
  margin-right: ${theme.spacing(2)}px;
`
